import { cn } from '@/lib/utils'
import { fadeIn } from '@/v2/constants/motion'
import { domAnimation, LazyMotion, m } from 'framer-motion'

interface SectionHeadProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  description?: string
  className?: string
}

const SectionHead: React.FC<SectionHeadProps> = props => {
  const { title, description, className } = props

  return (
    <LazyMotion features={domAnimation}>
      <m.div
        variants={fadeIn('down', 'tween', 0, 1)}
        title={title}
        className={cn(
          'text-center xl-min:!mb-12 md-mn:mb-6 mb-4 mx-auto [&>h2]:text-[24px] xl-min:[&>h2]:leading-[56px] [&>h2]:mx-auto [&>h2]:leading-[38px] [&>h2]:font-bold [&>h2]:text-heading-home xl-min:[&>h2]:text-[36px]',
          className ? className : 'md-mn:max-w-[80%] max-w-[97%]'
        )}
      >
        <h2 title={title}>{title}</h2>

        {description && (
          <p className='text-paragraph xl-min:text-xl text-lg font-medium xl-min:leading-[30px] leading-7 mx-auto xl-min:mt-4 mt-3'>
            {description}
          </p>
        )}
      </m.div>
    </LazyMotion>
  )
}
export default SectionHead
